import { Card, Row, Col } from "react-bootstrap";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import { useEffect } from "react";
import Div from "components/Div";
import { DEV_URL, rpost } from "../../utils/requests";
import React, { useState } from "react";
import { useNavigate ,useLocation } from "react-router-dom";
import Text from "components/Text";
import { NotificationsData } from "./notificationContents/notificationData";
import { useApiFilters } from "../../hooks/useApiFilters";
import PageTitle from "../../components/PageTitle/index";



const ManageNotifications = ({companyId }) => {
        const location = useLocation();
        const navigate = useNavigate();
        const queryParams = new URLSearchParams(location.search);
    const [notificationData, setNotificationData] = useState();
    const [companyDataPage, setCompanyDataPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [noDataMessage, setNoDataMessage] = useState('No Data Found');
    const [pageSizes, setPageSizes] = useState([]);
    const [companyDataPerPage, setCompanyDataPerPage] = useState(50);
    const [show,setShow] = useState(false);
    const [message,setMessage] = useState('');
    const handleClose =()=>{
        setShow(false);
    }
    const onViewMessage = async (messageContent,id)=>{
        await markById(id,true);
        setMessage(messageContent);
        setShow(true);
    }
    const {
        filters,
        orderBy,
        ascendingOrder,
        limit,
        page,
        search,
        setPage,
        setSearch,
        hook,
        setFilters
    } = useApiFilters({
        page: 0, limit: 50, filters: {
            search : '',
            from : '',
            to :''
        }
    });
    const paginationComponentOptions = {
        rowsPerPageText: "Rows per Page",
        rangeSeparatorText: "of",
        selectAllRowsItem: true,
        selectAllRowsItemText: "All",
    };
    const markById = async (id,isRead)=> {
        var payload = {id,isRead,isAll:false };
        const response = await rpost(`${DEV_URL}/api/Notification/Mark`,payload);
        if(response?.data!=null){
            if(response?.data==true){
                const notificationsResponse = await rpost(
                    `${DEV_URL}/api/Notification/GetAll`,
                    { PageNumber: page+1, PageSize: limit, SearchTerm: search?.trim(), orderBy: orderBy === undefined ? null : orderBy, ascendingOrder, from: filters.from, to: filters.to }
                );
                if (notificationsResponse !== 'Data not found') {
                    setNotificationData(notificationsResponse.data.records);
                    setTotalRecords(notificationsResponse.data.total);
                    navigate(window.location.pathname, { replace: true });
                }
                return true;
            }
        }
        return false;
    }
    // const allread = async ()=>{
    //     var payload = {id:null,isRead:true,isAll:true };
    //             const response = await rpost(`${DEV_URL}/api/Notification/Mark`,payload);
    //             if(response?.data!=null){
    //                 if(response?.data==true){
    //                     if(window.location.href.includes('/notifications')){
    //                         history.replace(window.location.pathname);
    //                     }
    //                 }
    //             }
    // }
        const removeById = async (id)=>{
            var payload = {id,isAll:false };
            const response = await rpost(`${DEV_URL}/api/Notification/Remove`,payload);
            if(response?.data!=null){
                if(response?.data==true){
                    return true;
                }
            }
            return false;
        }
    useEffect(() => {
        document.title = "DataHub - Notifications";
    }, []);

    useEffect(() => {
        const fetcher = async () => {
            if(queryParams.has('ReadAll')){
                navigate(window.location.pathname, { replace: true });
            } else{
                setLoading(true);
            
            const notificationsResponse = await rpost(
                `${DEV_URL}/api/Notification/GetAll`,
                { PageNumber: page+1, PageSize: limit, SearchTerm: search?.trim(), orderBy: orderBy === undefined ? null : orderBy, ascendingOrder, from: filters.from, to: filters.to }
            );
            if (notificationsResponse !== 'Data not found') {
                setNotificationData(notificationsResponse.data.records);
                setTotalRecords(notificationsResponse.data.total);
            }
            setLoading(false);
            }       
            
        }
        fetcher();
    }, [limit, page, search, orderBy, ascendingOrder,location.search, filters.from, filters.to])
    
    return (
       <> <ConfirmationModal
        dialogClassName="modal-md"
        show={show}
        onHide={handleClose}
        title="Message Content"
        confirmButtonLabel="Close"
        onConfirm={handleClose}
    >
            <h5 className="text-center">{message}</h5>
    </ConfirmationModal>
    <Div className="">
        <div className="">
            <PageTitle title="Notifications" />
        </div>
    </Div>
    <Div className="mt-3">
        <Row>
            <Col lg="12">
                <Card>
                    <Card.Body>
                        <NotificationsData total={totalRecords}
                            hook={hook} loading={loading} noDataMessage={noDataMessage} pageSizes={pageSizes} notifications={notificationData}></NotificationsData>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </Div></>);
};

export default ManageNotifications;
